export default __webpack_public_path__ + "static/media/gitboard.7b5e9344.svg";